import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { MODE_OPTIONS, modeFromSettings } from '../../lib/settingsMode';
import HelpTip from '../HelpTip';
const ModeSelector = ({ draft, onChange, disabled }) => (
  <div className="mb-4">
    <h5>
      What should Rate Shop do?{' '}
      <HelpTip label="Mode">
        Off does nothing. Test mode records choices without changing orders.
        Live writes the chosen carrier, service and package to ShipStation.
      </HelpTip>
    </h5>
    <p className="small text-muted">Choose a mode, then save your settings.</p>
    <Row className="g-3">
      {MODE_OPTIONS.map(mode => (
        <Col key={mode.id} md={4}>
          <Card
            className={`h-100 border ${
              modeFromSettings(draft) === mode.id
                ? 'border-primary bg-light'
                : ''
            }`}
          >
            <Card.Body>
              <Form.Check
                id={`rate-shop-mode-${mode.id}`}
                type="radio"
                name="rate-shop-mode"
                label={<strong>{mode.label}</strong>}
                disabled={disabled}
                checked={modeFromSettings(draft) === mode.id}
                onChange={() => onChange(mode.id)}
              />
              <p className="small text-muted mt-2 mb-0">
                {mode.help}
                <HelpTip label={mode.label}>{mode.help}</HelpTip>
              </p>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  </div>
);
export default ModeSelector;
